import autoTable from "jspdf-autotable";
import {  PDF_TABLE_STYLE,PDFCOLORSHEME } from "../../../../../../component/constent";

function format(value) {
  return Number(value || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function drawGrandTotal(doc, totals) {
 let startY = doc.lastAutoTable
    ? doc.lastAutoTable.finalY +5
    : 35;

  const pageHeight = doc.internal.pageSize.getHeight();

  if (startY > pageHeight - 40) {
    doc.addPage();
    startY = 35;
  }


 autoTable(doc, {
  startY,
  ... PDF_TABLE_STYLE,
  tableWidth: 160, // Total table width

  body: [[
    "GRAND TOTAL",
    format(totals.noofcoaches ),
    format(totals.Mech_LabourCost),
    format(totals.Mech_MaterialCost),
    format(totals.Elec_LabourCost),
    format(totals.Elec_MaterialCost),
    format(totals.totalcost),
  ]],

  styles: {
    fontSize: PDFCOLORSHEME.FONT_SIZE_GRAND_TOTAL,
    textColor:PDFCOLORSHEME.FONT_COLOR_GRAND_TOTAL,
    cellPadding: 2,
    halign: "right",
  },



 0: { cellWidth: 30, halign: "right" },
    1: { cellWidth: 30, halign: "right" },
    2: { cellWidth: 30, halign: "right" },
    3: { cellWidth: 35, halign: "right" },
     4: { cellWidth: 35, halign: "right" },
      5: { cellWidth: 39, halign: "right" },
       6: { cellWidth: 38, halign: "right" },
       7: { cellWidth: 38, halign: "right" },
      



  columnStyles: {
    0: { cellWidth: 60, halign: "right" },
    1: { cellWidth: 33, halign: "right" },
    2: { cellWidth: 33, halign: "right" },
    3: { cellWidth: 35, halign: "right" },
     4: { cellWidth: 38, halign: "right" },
      5: { cellWidth: 39, halign: "right" },
       6: { cellWidth: 38, halign: "right" },
      



  },

  didParseCell(data) {
    if (data.section === "body") {
      data.cell.styles.fontStyle = "bold";
      data.cell.styles.fillColor = PDFCOLORSHEME.BACK_COLOR_GRAND_TOTAL;
      
    }
  },
});
}